import React, { useState, MouseEvent } from 'react';
import cn from 'classnames';
import Image from '@base/lib/ThemeImage';
import type { IKitProductVariant, IVariant } from 'base/interfaces/product';
import type { IImage } from 'base/interfaces/product';
import { getMainPicUrl, getVariantImagesList } from 'base/utils/getPicUrl';
import styles from './index.module.less';
import TabPartTitle from '@app/product/TabPartTitle';
import { Trans, useTrans } from 'base/utils/i18n';
import { ProductDetailPopup } from '@app/common/ProductDetailPopup';

type IProps = {
    shownVariant: IVariant;
    canJump?: boolean;
}

type IVariantProductProps = {
    item: IKitProductVariant;
    index: number;
    onClick?: (e: MouseEvent) => void;
    className?: string;
    canJump: boolean;
}

// 找到显示variant 显示图片
const getMainImage = (pics: IImage[], productVariantId: string) => {
    const _pics = getVariantImagesList(pics, productVariantId)
    return getMainPicUrl(_pics || pics)
}

const VariantProduct = ({ item, index, onClick, canJump }: IVariantProductProps) => {
    const {
        pics,
        productVariantId,
    } = item

    const imgUrl = getMainImage(pics, productVariantId)

    return (
        <div
            key={index}
            className={cn(styles.item, { [styles['can-jump']]: canJump })}
            onClick={onClick}
        >
            <div className={styles.img}>
                <Image
                    src={imgUrl}
                    alt={imgUrl}
                    width={175}
                />
            </div>
            <div className={styles.info}>
                <p className={styles.index}>{item.kitNum} of</p>
                <p className={styles.name}>
                    {item.name}
                </p>
            </div>
        </div>
    )
}

const KitProducts: React.FC<IProps> = (props) => {
    const { shownVariant, canJump = true } = props

    const [popupVisible, setPopupVisible] = useState<boolean>(false)
    const [popupVariantId, setPopupVariantId] = useState<string>()
    const { t } = useTrans()

    return (
        <div className={cn(styles["kit-products"], 'wrapper')}>

            <TabPartTitle title={t('web_product_tab_bundle_list')}/>

            <div className={styles.content}>
                {shownVariant && (
                    <>
                        <div className={styles.messages}>
                            <p className={styles.title}>
                                <Trans
                                    i18nKey="web_product_bundle_contains"
                                    values={{ num: shownVariant?.kitProductVariantList?.length }}
                                    components={{ span: <span className={'text-muted'}/> }}
                                />
                            </p>
                            <p className={styles.msg}>
                                {t('web_product_bundle_price')}: {shownVariant.dealPriceExchangeDisplay || shownVariant.shopPriceExchangeDisplay}
                            </p>
                            {shownVariant?.savePrice && shownVariant.savePrice > 0 && (
                                <p className={styles.msg}>
                                    {t('web_product_bundle_save')}: {shownVariant.savePriceExchangeDisplay}
                                </p>
                            )}
                        </div>

                        <div className={styles.items}>
                            {shownVariant?.kitProductVariantList.map((item, index) => {
                                return (
                                    <VariantProduct
                                        key={index}
                                        item={item}
                                        index={index}
                                        canJump={canJump}
                                        onClick={(e) => {
                                            if (canJump) {
                                                e.stopPropagation()
                                                setPopupVariantId(item.productVariantId)
                                                setPopupVisible(true);
                                            }
                                        }}
                                    />
                                )
                            })
                            }
                        </div>
                    </>
                )}
            </div>

            {!!popupVariantId && (
                <ProductDetailPopup
                    variantId={popupVariantId}
                    visible={popupVisible}
                    onClose={() => setPopupVisible(false)}
                    hiddenElements={['addCartForm']}
                />
            )}
        </div>
    )
}

export default KitProducts